var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instance-purchase-new-thank-you"},[_c('nuttrema-empty-result',{staticClass:"with-logo",attrs:{"predefined-set":"thank-you"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a83a90","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/instance/subscriptions/purchase-new/step-3/page-instance-purchase-new-thank-you.vue
// module id = 3198
// module chunks = 0